import * as React from 'react';
import { useSelector } from 'react-redux';
import { Promo as PromoComponent } from '../../components/Promo';
import { PromoIntro } from '../../components/PromoIntro';
import { PromoPreview } from '../../components/PromoPreview';
import { getNewbuildingId, getPromo, getPromosForPreview } from '../../selectors/newbuilding';
import { IPromo } from '../../types/newbuilding/promos';
import { getPromoDate, getPromoIcon } from '../../utils/promos';
import { PromoDescriptionModalContainer } from '../PromoDescriptionModal';
import { PromoLink } from '../PromoLink';
import { trackClickPromoBlock, trackHoverPromoBlock } from '../Promos/tracking';

export const Promo = () => {
  const [selectedPromo, setSelectedPromo] = React.useState<IPromo | null>(null);

  const promo = useSelector(getPromo);
  const promosToPreview = useSelector(getPromosForPreview);
  const newbuildingId = useSelector(getNewbuildingId);

  const closePromo = React.useCallback(() => {
    setSelectedPromo(null);
  }, []);

  const openPromo = React.useCallback(
    (promoInfo: IPromo) => {
      setSelectedPromo(promoInfo);
      trackClickPromoBlock({
        newbuildingId,
        promoType: promoInfo.promoType,
        promotionId: promoInfo.promoId,
      });
    },
    [newbuildingId],
  );

  const openMainPromo = React.useCallback(() => {
    openPromo(promo as IPromo);
  }, [promo, openPromo]);

  const hoverPromo = React.useCallback(
    (promoInfo: IPromo) => {
      trackHoverPromoBlock({
        newbuildingId,
        promoType: promoInfo.promoType,
        promotionId: promoInfo.promoId,
      });
    },
    [newbuildingId],
  );

  const hoverMainPromo = React.useCallback(() => {
    hoverPromo(promo as IPromo);
  }, [promo, hoverPromo]);

  const promoDate = React.useMemo(() => getPromoDate(promo), [promo]);
  const promoIcon = React.useMemo(() => getPromoIcon(promo), [promo]);

  if (!promo) {
    return null;
  }

  return (
    <>
      <PromoComponent
        promo={
          <PromoIntro
            dueDate={promoDate}
            name={promo.name}
            subtitle={promo.subtitle}
            onClick={openMainPromo}
            onHover={hoverMainPromo}
            icon={promoIcon}
            isFromBank={promo.isFromBank}
          />
        }
        link={<PromoLink />}
        previews={
          promosToPreview.length ? (
            <PromoPreview promos={promosToPreview} onPromoClick={openPromo} onPromoHover={hoverPromo} />
          ) : null
        }
      />
      {selectedPromo && <PromoDescriptionModalContainer open={true} onClose={closePromo} promo={selectedPromo} />}
    </>
  );
};
